import { render, staticRenderFns } from "./AddProdukOnboarding.vue?vue&type=template&id=345dc7e6&"
import script from "./AddProdukOnboarding.vue?vue&type=script&lang=js&"
export * from "./AddProdukOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./AddProdukOnboarding.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports